import { ResponseGetMerchflowTemplateAllStores_templateId_ } from "@CommonApi/merchflow/template/all-stores/_templateId_";
import { omniAtom } from "src/utils/atoms";

export const assignedStoresAtom = omniAtom({
  prefix: "modals",
  key: "assignedStores",
  value: null as ResponseGetMerchflowTemplateAllStores_templateId_ | null,
});
